export const labTemplates = {
    // Haematology
    "cbc": [
        { key: "hemoglobin", name: "Hemoglobin (Hb)", unit: "g/dL", min: 12.0, max: 15.5 },
        { key: "rbc", name: "Red Blood Cells (RBC)", unit: "mill/mm3", min: 4.0, max: 5.5 },
        { key: "wbc", name: "White Blood Cells (WBC)", unit: "/c.mm", min: 4000, max: 11000 },
        { key: "platelets", name: "Platelet Count", unit: "lacs/c.mm", min: 1.5, max: 4.5 },
        { key: "hct", name: "Hematocrit (PCV)", unit: "%", min: 36.0, max: 46.0 },
        { key: "mcv", name: "Mean Corpuscular Vol (MCV)", unit: "fL", min: 83.0, max: 101.0 }
    ],
    "esr": [
        { key: "esr", name: "ESR (Westergren)", unit: "mm/hr", min: 0, max: 20 }
    ],
    "hemoglobin": [
        { key: "hemoglobin", name: "Hemoglobin (Hb)", unit: "g/dL", min: 12.0, max: 15.5 }
    ],

    // Biochemistry
    "lft": [
        { key: "bilirubin_total", name: "Bilirubin (Total)", unit: "mg/dL", min: 0.1, max: 1.2 },
        { key: "bilirubin_direct", name: "Bilirubin (Direct)", unit: "mg/dL", min: 0.0, max: 0.3 },
        { key: "sgot", name: "SGOT (AST)", unit: "U/L", min: 5, max: 40 },
        { key: "sgpt", name: "SGPT (ALT)", unit: "U/L", min: 7, max: 56 },
        { key: "alp", name: "Alkaline Phosphatase (ALP)", unit: "U/L", min: 44, max: 147 },
        { key: "total_protein", name: "Total Protein", unit: "g/dL", min: 6.0, max: 8.3 },
        { key: "albumin", name: "Albumin", unit: "g/dL", min: 3.4, max: 5.4 }
    ],
    "kft": [
        { key: "urea", name: "Blood Urea", unit: "mg/dL", min: 10, max: 50 },
        { key: "creatinine", name: "Serum Creatinine", unit: "mg/dL", min: 0.5, max: 1.2 },
        { key: "uric_acid", name: "Uric Acid", unit: "mg/dL", min: 3.5, max: 7.2 },
        { key: "sodium", name: "Sodium", unit: "mEq/L", min: 135, max: 145 },
        { key: "potassium", name: "Potassium", unit: "mEq/L", min: 3.5, max: 5.1 },
        { key: "chloride", name: "Chloride", unit: "mEq/L", min: 98, max: 107 }
    ],
    "lipid_profile": [
        { key: "cholesterol", name: "Total Cholesterol", unit: "mg/dL", min: 0, max: 200 },
        { key: "triglycerides", name: "Triglycerides", unit: "mg/dL", min: 0, max: 150 },
        { key: "hdl", name: "HDL Cholesterol", unit: "mg/dL", min: 40, max: 60 },
        { key: "ldl", name: "LDL Cholesterol", unit: "mg/dL", min: 0, max: 100 },
        { key: "vldl", name: "VLDL Cholesterol", unit: "mg/dL", min: 2, max: 30 }
    ],
    "electrolytes": [
        { key: "sodium", name: "Sodium", unit: "mEq/L", min: 135, max: 145 },
        { key: "potassium", name: "Potassium", unit: "mEq/L", min: 3.5, max: 5.1 },
        { key: "chloride", name: "Chloride", unit: "mEq/L", min: 98, max: 107 }
    ],
    "uric_acid": [
        { key: "uric_acid", name: "Uric Acid", unit: "mg/dL", min: 3.5, max: 7.2 }
    ],
    "calcium": [
        { key: "calcium", name: "Calcium (Total)", unit: "mg/dL", min: 8.5, max: 10.5 }
    ],
    "ferritin": [
        { key: "ferritin", name: "Serum Ferritin", unit: "ng/mL", min: 30, max: 400 }
    ],
    "iron_profile": [
        { key: "iron", name: "Serum Iron", unit: "ug/dL", min: 60, max: 170 },
        { key: "tibc", name: "TIBC", unit: "ug/dL", min: 240, max: 450 },
        { key: "transferrin_sat", name: "Transferrin Saturation", unit: "%", min: 20, max: 50 }
    ],

    // Diabetic Profile
    "fbs": [
        { key: "glucose_fasting", name: "Glucose (Fasting)", unit: "mg/dL", min: 70, max: 100 }
    ],
    "ppbs": [
        { key: "glucose_pp", name: "Glucose (Post Prandial)", unit: "mg/dL", min: 70, max: 140 }
    ],
    "rbs": [
        { key: "glucose_random", name: "Glucose (Random)", unit: "mg/dL", min: 70, max: 140 }
    ],
    "hba1c": [
        { key: "hba1c", name: "HbA1c", unit: "%", min: 4.0, max: 5.6 }
    ],

    // Thyroid & Hormones
    "thyroid_profile": [
        { key: "t3", name: "Total T3", unit: "ng/dL", min: 80, max: 200 },
        { key: "t4", name: "Total T4", unit: "ug/dL", min: 4.5, max: 12.0 },
        { key: "tsh", name: "TSH", unit: "uIU/mL", min: 0.4, max: 4.0 }
    ],
    "tsh_standalone": [
        { key: "tsh", name: "TSH", unit: "uIU/mL", min: 0.4, max: 4.0 }
    ],
    "free_thyroid": [
        { key: "ft3", name: "Free T3", unit: "pg/mL", min: 2.3, max: 4.2 },
        { key: "ft4", name: "Free T4", unit: "ng/dL", min: 0.89, max: 1.76 }
    ],
    "prolactin": [
        { key: "prolactin", name: "Prolactin", unit: "ng/mL", min: 4.8, max: 23.3 }
    ],
    "fsh": [
        { key: "fsh", name: "FSH", unit: "mIU/mL", min: 1.5, max: 12.4 }
    ],
    "lh": [
        { key: "lh", name: "LH", unit: "mIU/mL", min: 1.7, max: 8.6 }
    ],
    "testosterone": [
        { key: "testosterone", name: "Testosterone Total", unit: "ng/dL", min: 240, max: 950 }
    ],
    "cortisol": [
        { key: "cortisol", name: "Cortisol (Morning)", unit: "ug/dL", min: 6.0, max: 23.0 }
    ],
    "beta_hcg": [
        { key: "beta_hcg", name: "Beta HCG", unit: "mIU/mL", min: 0, max: 5 }
    ],

    // Vitamins (Added)
    "vitamin_d": [
        { key: "vit_d", name: "Vitamin D (25-OH)", unit: "ng/mL", min: 30, max: 100 }
    ],
    "vitamin_b12": [
        { key: "vit_b12", name: "Vitamin B12", unit: "pg/mL", min: 200, max: 900 }
    ],

    // Serology & Infectious Markers
    "crp": [
        { key: "crp", name: "C-Reactive Protein", unit: "mg/L", min: 0, max: 6 }
    ],
    "ra_factor": [
        { key: "ra_factor", name: "Rheumatoid Factor", unit: "IU/mL", min: 0, max: 14 }
    ],
    "anti_ccp": [
        { key: "anti_ccp", name: "Anti-CCP", unit: "U/mL", min: 0, max: 20 }
    ],
    "ana": [
        { key: "ana_titer", name: "ANA Titer", unit: "Ratio", min: 0, max: 1 } // qualitative usually
    ],
    "widal": [
        { key: "widal_o", name: "Widal TO", unit: "Titer", min: 0, max: 80 },
        { key: "widal_h", name: "Widal TH", unit: "Titer", min: 0, max: 80 },
        { key: "widal_ah", name: "Widal TAH", unit: "Titer", min: 0, max: 80 },
        { key: "widal_bh", name: "Widal TBH", unit: "Titer", min: 0, max: 80 }
    ],
    "dengue_ns1": [
        { key: "dengue_ns1", name: "Dengue NS1 Antigen", unit: "Result", min: 0, max: 0.9 }
    ],
    "dengue_serology": [
        { key: "dengue_igg", name: "Dengue IgG", unit: "Ratio", min: 0, max: 1.1 },
        { key: "dengue_igm", name: "Dengue IgM", unit: "Ratio", min: 0, max: 1.1 }
    ],
    "malaria": [
        { key: "mp_smear", name: "M.P. Smear", unit: "Result", min: 0, max: 0 }
    ],
    "syphilis": [
        { key: "vdrl", name: "VDRL (Syphilis)", unit: "Titer", min: 0, max: 0 }
    ],
    "hepatitis_b": [
        { key: "hbsag", name: "HBsAg (Hepatitis B)", unit: "COI", min: 0, max: 1 }
    ],
    "hepatitis_c": [
        { key: "hcv", name: "HCV (Hepatitis C)", unit: "COI", min: 0, max: 1 }
    ],
    "hiv": [
        { key: "hiv", name: "HIV 1 & 2 Antibodies", unit: "COI", min: 0, max: 1 }
    ],
    "rt_pcr": [
        { key: "covid_result", name: "RT-PCR (COVID-19)", unit: "Result", min: 0, max: 0 }
    ],

    // Pathology & Miscellaneous
    "urine_routine": [
        { key: "ph", name: "pH", unit: "", min: 4.5, max: 8.0 },
        { key: "specific_gravity", name: "Specific Gravity", unit: "", min: 1.005, max: 1.030 },
        { key: "wbcs", name: "Pus Cells / WBCs", unit: "/hpf", min: 0, max: 5 },
        { key: "rbcs", name: "RBCs", unit: "/hpf", min: 0, max: 2 }
    ],
    "urine_culture": [
        { key: "growth", name: "Growth", unit: "CFU/mL", min: 0, max: 100000 }
    ],
    "semen_analysis": [
        { key: "volume", name: "Volume", unit: "mL", min: 1.5, max: 5.0 },
        { key: "count", name: "Sperm Count", unit: "mill/mL", min: 15, max: 200 },
        { key: "motility", name: "Total Motility", unit: "%", min: 40, max: 100 }
    ],
    "stool_routine": [
        { key: "color", name: "Color", unit: "", min: 0, max: 0 },
        { key: "mucus", name: "Mucus", unit: "", min: 0, max: 0 },
        { key: "parasites", name: "Parasites", unit: "", min: 0, max: 0 }
    ],
    "sputum_afb": [
        { key: "afb_result", name: "Sputum AFB", unit: "Result", min: 0, max: 0 }
    ],
    "psa": [
        { key: "psa", name: "Prostate Specific Antigen (PSA)", unit: "ng/mL", min: 0, max: 4.0 }
    ],

    // Imaging Narrative Templates
    "imaging_report": [
        { key: "findings", name: "Findings", unit: "Text", min: 0, max: 0 },
        { key: "impression", name: "Impression", unit: "Text", min: 0, max: 0 }
    ]
};

// Precise alias mapping to handle complex test names from DB
const aliasMap = {
    "completebloodcount": labTemplates.cbc,
    "cbc": labTemplates.cbc,
    "hemoglobinhb": labTemplates.hemoglobin,
    "erythrocytesedimentationrateesr": labTemplates.esr,
    "esr": labTemplates.esr,
    
    // Diabetic
    "fastingbloodsugarfbs": labTemplates.fbs,
    "fbs": labTemplates.fbs,
    "postprandialbloodsugarppbs": labTemplates.ppbs,
    "ppbs": labTemplates.ppbs,
    "randombloodsugarrbs": labTemplates.rbs,
    "rbs": labTemplates.rbs,
    "hba1c": labTemplates.hba1c,

    // Liver
    "liverfunction": labTemplates.lft,
    "lft": labTemplates.lft,
    "bilirubintotaldirect": labTemplates.lft,
    "sgotast": labTemplates.lft,
    "sgptalt": labTemplates.lft,
    "alkalinephosphatasealp": labTemplates.lft,
    "totalproteinalbuminglobulin": labTemplates.lft,

    // Kidney / Renal
    "kidneyfunction": labTemplates.kft,
    "renalfunction": labTemplates.kft,
    "kft": labTemplates.kft,
    "serumcreatinine": labTemplates.kft,
    "bloodureanitrogenbun": labTemplates.kft,
    "uricacid": labTemplates.uric_acid,
    "serumelectrolytesnakcl": labTemplates.electrolytes,

    // Lipid
    "lipidprofile": labTemplates.lipid_profile,
    "cholesteroltotal": labTemplates.lipid_profile,
    "triglycerides": labTemplates.lipid_profile,

    // Hormones
    "thyroidprofilet3t4tsh": labTemplates.thyroid_profile,
    "tshtsh": labTemplates.tsh_standalone,
    "freet3freet4": labTemplates.free_thyroid,
    "prolactin": labTemplates.prolactin,
    "fshfolliclestimulatinghormone": labTemplates.fsh,
    "lhluteinizinghormone": labTemplates.lh,
    "testosteronetotal": labTemplates.testosterone,
    "cortisolmorning": labTemplates.cortisol,
    "betahcgpregnancytest": labTemplates.beta_hcg,

    // Vitamins
    "vitamind25oh": labTemplates.vitamin_d,
    "vitaminb12": labTemplates.vitamin_b12,

    // Serology
    "creactiveproteincrp": labTemplates.crp,
    "widaltesttyphoid": labTemplates.widal,
    "denguens1antigen": labTemplates.dengue_ns1,
    "dengueiggigm": labTemplates.dengue_serology,
    "malariaparasitempsmear": labTemplates.malaria,
    "hiv12antibodies": labTemplates.hiv,
    "hbsaghepatitisb": labTemplates.hepatitis_b,
    "hcvhepatitisc": labTemplates.hepatitis_c,
    "vdrlsyphilis": labTemplates.syphilis,
    "rheumatoidfactorratest": labTemplates.ra_factor,
    "anticcp": labTemplates.anti_ccp,
    "anaantinuclearantibody": labTemplates.ana,
    "rtpcrcovid19": labTemplates.rt_pcr,

    // Misc
    "urineroutinemicroscopy": labTemplates.urine_routine,
    "urineculture": labTemplates.urine_culture,
    "stoolroutineexamination": labTemplates.stool_routine,
    "semenanalysis": labTemplates.semen_analysis,
    "prostatespecificantigenpsa": labTemplates.psa,
    "psa": labTemplates.psa,
    "tshthyroidstimulatinghormone": labTemplates.tsh_standalone,
    "tsh": labTemplates.tsh_standalone,
    "bloodculture": labTemplates.urine_culture, // Use similar fallback
    "sputumafb": labTemplates.sputum_afb,
    "calciumtotal": labTemplates.calcium,
    "serumferritin": labTemplates.ferritin,
    "ironprofile": labTemplates.iron_profile,

    // Imaging
    "electrocardiogramecg": labTemplates.imaging_report,
    "xraychestpaview": labTemplates.imaging_report,
    "usgwholeabdomenultrasound": labTemplates.imaging_report
};

// Helper function to find a template
export const getTemplateForTest = (testName) => {
    if (!testName) return null;
    const normalized = testName.toLowerCase().replace(/[^a-z0-9]/g, '');

    // 1. Try direct alias mapping (highest accuracy)
    if (aliasMap[normalized]) {
        return aliasMap[normalized];
    }

    // 2. Try substring match against alias keys
    for (const [key, template] of Object.entries(aliasMap)) {
        if (normalized.includes(key) || key.includes(normalized)) {
            return template;
        }
    }

    // 3. Fallback to base labTemplates keys
    for (const [key, params] of Object.entries(labTemplates)) {
        if (normalized.includes(key.replace(/_/g, ''))) {
            return params;
        }
    }

    return null;
};

